// TODO remove Marketplace when we add the option to name a custom service
export const serviceOptionsToAdd = ['Data Transfer - Amazon CloudFront', 'Marketplace'];
export const supportedCalcCostServices = ['AWS Support [Business]', 'AWS Support [Developer]', 'AWS Premium Support'];
export const percentageMargins = ['percentage', 'custom-service-calc-cost'];
